
export const useAuthHeader = () => {

    const getAuthToken = () => {
        return window.localStorage.getItem('auth_token');
    };
    
    const setAuthHeader = async (token) => {
        if (token !== null) {
          window.localStorage.setItem("auth_token", token);
        } else {
          window.localStorage.removeItem("auth_token");
        }
    };
    
    const removeAuthHeader = () => {
        window.localStorage.removeItem("auth_token");
    }

    return {getAuthToken, setAuthHeader, removeAuthHeader}
}